var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_13521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0042 2.6671H10.5309V0.889088C10.5303 0.652409 10.4358 0.425655 10.2682 0.258533C10.1006 0.0914112 9.87356 -0.00244235 9.63688 -0.00244141H1.61566C1.37921 -0.00244141 1.15244 0.0914929 0.985249 0.258687C0.818055 0.42588 0.724121 0.65264 0.724121 0.889088V10.5977C0.724121 10.8341 0.818055 11.0609 0.985249 11.2281C1.15244 11.3953 1.37921 11.4892 1.61566 11.4892H3.4944V12.7257C3.49439 13.0609 3.62666 13.3825 3.86245 13.6206C4.09825 13.8588 4.4185 13.9942 4.75362 13.9976H12.0042C12.1722 13.9989 12.3388 13.967 12.4944 13.9037C12.65 13.8404 12.7916 13.747 12.9109 13.6288C13.0303 13.5106 13.1251 13.37 13.1899 13.215C13.2547 13.06 13.2883 12.8937 13.2886 12.7257V3.9364C13.29 3.76805 13.2576 3.60113 13.1934 3.44552C13.1291 3.2899 13.0343 3.14875 12.9146 3.03041C12.7948 2.91208 12.6525 2.81895 12.4962 2.75655C12.3398 2.69415 12.1725 2.66373 12.0042 2.6671ZM12.5331 12.7257C12.5331 12.8627 12.4787 12.994 12.3819 13.0908C12.2851 13.1876 12.1537 13.242 12.0168 13.242H4.76371C4.62897 13.2387 4.50087 13.1829 4.40675 13.0864C4.31264 12.99 4.25998 12.8605 4.26002 12.7257V11.4917H9.63688C9.87356 11.4917 10.1006 11.3979 10.2682 11.2307C10.4358 11.0636 10.5303 10.8369 10.5309 10.6002V3.42264H12.0042C12.0714 3.42096 12.1383 3.43274 12.2008 3.4573C12.2634 3.48186 12.3204 3.5187 12.3685 3.56564C12.4166 3.61258 12.4549 3.66867 12.481 3.73062C12.5071 3.79256 12.5205 3.85911 12.5205 3.92632L12.5331 12.7257Z",
    fill: "#4CB596"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_13521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.5519,
    height: 14,
    fill: "white",
    transform: "translate(0.724121)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.00420d44ee3b93b37453fcdb875a11be.svg";
export { ForwardRef as ReactComponent };